// eslint-disable-next-line react/prop-types
const Alphanine = ({ themeColor }) => {
  return (
    <>
      <div className="text-xl md:text-3xl font-bold">
        <span style={{ color: themeColor }}>MEDICAL BENEFITS BILLING PORTAL FOR PROVIDERS.</span>
        <p className="my-2">
          FOR COPAY ASSISTANCE, FREE TRIAL AND PATIENT ASSISTANCE
        </p>
      </div>

      <p className="my-2 mt-10 font-bold">COPAY ASSISTANCE PROGRAM</p>

      <p className="my-2">If your patient’s primary payer drug claim is billed under medical benefits, you can request
        ALPHANATE® (antihemophilic factor/von Willebrand factor complex [human]) and AlphaNine® SD (coagulation factor
        IX [human]) Copay assistance using this portal. ​The Copay Assistance Program may cover eligible patients'
        out-of-pocket expenses not covered or partially covered by their insurance, with no annual monthly limits.</p>

      <p className="my-2 font-bold">Eligibility Criteria for Copay Assistance</p>

      <ul className="my-2 list-disc ml-10">
        <li>Patient must have a covered diagnosis. Please see the Billing Information tab for covered codes.</li>
      </ul>

      <p className="my-2">
        Care Coordination to help your patients gain access to and remain on ALPHANATE or AlphaNine SD
      </p>

      <p className="my-2">
        Note: Nursing and supply costs that may be associated with the administration of the medication are not eligible
        for assistance through this program. For both medical and pharmacy benefits, claims must be received within 45
        days of dispense date. For medical benefits only, EOBs must also be submitted within 180 days of the date the
        claim was submitted.
      </p>

      <p className="my-2 font-bold mt-10">FREE TRIAL PROGRAM</p>

      <p className="my-2">Free trial drug available to your patients who are new to ALPHANATE or AlphaNine SD and have
        not used a free trial offer for the product before. You can request up to 3 total doses with a maximum of 12,000
        IUs through this Free Trial program.</p>

      <p className="my-2 font-bold">Eligibility Criteria for Free Trial</p>

      <ul className="my-2 list-disc ml-10">
        <li>Patient who are new to ALPHANATE or AlphaNine SD</li>
        <li>Patient must be a US resident</li>
        <li>Patients are ineligible for free trial if they participate in Medicare, Medicaid, Medigap, Veterans Affairs,
          Department of Defense, Tricare, or any other federal or state-funded programs
        </li>
      </ul>


      <p className="my-2 font-bold mt-10">
        PATIENT ASSISTANCE PROGRAM
      </p>

      <p className="my-2">
        The Patient Assistance Program is for patients with no insurance coverage or lapsed coverage. This program
        offers free ALPHANATE or AlphaNine SD to uninsured who otherwise cannot afford their medications. Patients must
        meet financial and other program specific criteria to be eligible for assistance. The Patient Assistance Program
        provides up to a 30-day supply of ALPHANATE or AlphaNine SD per request, not to exceed 100,000 IUs over a
        calendar year or 20,000 IUs per month.
      </p>

      <p className="my-2 font-bold">Eligibility Criteria for Patient Assistance</p>

      <ul className="my-2 list-disc ml-10">
        <li>Income may not exceed 400% of federal poverty level</li>
        <li>Patient must be a US resident</li>
        <li>Patient Assistance Program is for on-label use only
        </li>
      </ul>
    </>
  )
}

export default Alphanine;